require('./cardStatements.scss');

const PropTypes = require('prop-types');

const React = require('react');
const CardStatementsContent = require('components/cards/cardStatements/cardStatementsContent/cardStatementsContent');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');

const CardStatements = props => {
    const {
        cardId,
        immScreen,
        immStatements,
        requestCardMoreStatements,
    } = props;

    let innerComponent;

    if (immStatements && !immStatements.get('loading')) {
        innerComponent = (
            <CardStatementsContent
                cardId={cardId}
                immScreen={immScreen}
                immStatements={immStatements}
                requestCardMoreStatements={requestCardMoreStatements}
            />
        );
    } else if (immStatements.get('loading')) {
        innerComponent = <LoadingSection />;
    }

    return (
        <div className="card-statements">
            {innerComponent}
        </div>
    )
};

CardStatements.propTypes = {
    cardId: PropTypes.string.isRequired,
    immScreen: PropTypes.object,
    immStatements: PropTypes.object,
    requestCardMoreStatements: PropTypes.func.isRequired,
}

module.exports = CardStatements;